export const conditions = {
  good: { value: 'good', text: 'Good' },
  fair: { value: 'fair', text: 'Fair' },
  poop: { value: 'poor', text: 'Poor' },
};

export const conditionsList = Object.values(conditions);

export const matchStatuses = {
  tis: {
    key: 'TIS',
    label: 'TC',
  },
  fsm: {
    key: 'FSM',
    label: 'FSM',
  },
  matched: {
    key: 'matched',
    label: 'Matched',
  },
  archived: {
    key: 'archived',
    label: 'Archived',
  },
};

// matchStatus === matchStatuses.fsm.key ('FSM') is ambiguous: the Source column's
// calcFilterExpression treats it as "matched OR unmatched FSM" (grouped by thirdPartyId2),
// so it can't express "still unmatched only". This sentinel tells calcFilterExpression to
// bypass that grouping and match the raw matchStatus DB value instead.
export const RAW_MATCH_STATUS_FSM = '__raw_matchStatus_fsm__';
